import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import MediaQuery from 'react-responsive';
import { Fill } from 'react-slot-fill';
import { Redirect } from 'react-router-dom';
import ExtraUserInformationForm from './ExtraUserInformationForm';
import styles from './ExtraUserInformation.css';
import Modal from '../Modal';

const ExtraUserInformationFormModal = ({
    title,
    subtitle,
    className,
    ...props
}) => {
    const children = [
        <h2 key="title">{title}</h2>,
        <div
            key="subtitle"
            className={styles.subtitle}
        >
            {subtitle}
        </div>,
        <ExtraUserInformationForm
            key="extra-user-info"
            {...props}
        />,
    ];
    return (<MediaQuery maxWidth={600}>
        {mobile => (mobile ? [
            <Redirect to="/more-info" key="redirect" />,
            <Fill
                name="modal-more-info"
                key="page"
            >
                <div className={styles.content}>
                    {children}
                </div>
            </Fill>,
        ] : <Modal
            open
            className={cx(styles.modal, styles.content, className)}
            fill="modal"
        >
            {children}
        </Modal>)}
    </MediaQuery>);
};

ExtraUserInformationFormModal.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    className: PropTypes.string,
};

ExtraUserInformationFormModal.defaultProps = {
    saveButton: 'Continue',
};

export default ExtraUserInformationFormModal;



// WEBPACK FOOTER //
// ./src/client/Components/ExtraUserInformationLakeCounty/ExtraUserInformationFormModal.js